import type React from 'react'
import {
  IconCabinSeat,
  IconFAQS,
  IconLounge,
  IconTicket,
  IconTipsBook,
} from '~/components/Icons'

const icons: Record<string, React.FC> = {
  ticket: IconTicket,
  lounge: IconLounge,
  cabin: IconCabinSeat,
  tips: IconTipsBook,
  faqs: IconFAQS,
}

export default function TabTitle({
  iconsvg,
  title,
}: { iconsvg: string | undefined; title: string }) {
  const IconComponent = iconsvg ? icons[iconsvg] : null
  const TabTitle = title || ''

  return IconComponent ? (
    <div>
      <div className="m-0 flex items-center justify-center md:[&>svg]:w-8  md:[&>svg]:h-8 [&>svg]:w-4  [&>svg]:h-4">
        <IconComponent />
      </div>
      <p className="text-center m-0">{TabTitle}</p>
    </div>
  ) : null
}
